import React, { useState } from 'react';
import { useIntl, useLocation } from 'umi';
import { DropdownBox, List, Popover } from 'tea-component';
import { SortHeaderCellProps } from 'ali-react-table';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { isRateColumn, isRateSortSupportedPath } from '../PerformanceMetricsTable/components/_utils';


// 列对齐方式与 Popover placement 的映射，参考 CommonTable 的实现
const PLACEMENT_MAP: Record<string, 'bottom-start' | 'bottom-end' | 'bottom'> = {
  left: 'bottom-start',
  right: 'bottom-end',
  center: 'bottom',
};

function HeatMapTableHeadCell({ children, sortOrder, column }: SortHeaderCellProps, records: any, handleTableCopy) {
  const [visible, setVisible] = useState(false);
  const { formatMessage } = useIntl();
  const location = useLocation();
  const pathName = location?.pathname || '';
  const align = column?.align || 'left';
  const placement = PLACEMENT_MAP[align] || 'bottom-start';

  // 升序 asc 降序 desc 默认 none
  const options = [
    {
      value: 'asc',
      text: formatMessage({ id: 'common_asc' }),
      icon: 'arrow-other-up'
    },
    { 
      value: 'desc', 
      text: formatMessage({ id: 'common_des' }),
      icon: 'arrow-other-down'
    },
    ...(isRateColumn(column) && isRateSortSupportedPath(pathName) ? [
      {
        value: 'asc_by_rate',
        text: formatMessage({ id: 'common_asc_by_rate' }),
        icon: 'arrow-other-up'
      },
      {
        value: 'desc_by_rate',
        text: formatMessage({ id: 'common_des_by_rate' }),
        icon: 'arrow-other-down'
      },
    ] : []),
    { 
      value: 'none', 
      text: formatMessage({ id: 'common_default_sort' }),
      icon: 'sort-icon'  
    },
  ];

  const handleCopy = (type: string) => {
    handleTableCopy(type, column?.code, children);
    setVisible(false);
  };
  return (
    <Popover
      visible={visible}
      closeOnScroll={true}
      onVisibleChange={(visible) => {
        setVisible(visible);
      }}
      placement={placement}
      trigger="click"
      overlay={
        <DropdownBox>
          <div className='dbd-performance-sort-overlay'>
            <List type="option">
              {options?.map((item: any) => {
                return <List.Item
                  key={item?.value}
                  className={sortOrder === item?.value ? 'is-selected' : ''}
                  onClick={(e) => {
                    // 使用表格表头注册的事件进行自定义排序 （取消使用onToggle(e)）
                    const sortItem = item?.value !== 'none' ? [{ code: column?.code || '', order: item?.value }] : [];
                    column?.onChangeSorts && column?.onChangeSorts(sortItem);
                    setVisible(false);
                    e.stopPropagation();
                  }}>
                  {
                    item?.icon && (
                      <SvgIcon
                        type={item.icon}
                        style={{ cursor: "pointer", marginRight: "5px"}}
                      />
                    )
                  }
                  {item?.text}
                </List.Item>;
              })}
            </List>
            <hr style={{ margin: '5px -6px' }} />
            <List type="option">
              {
                column.code === 'date' ? <List.Item onClick={() => handleCopy('date')}>{formatMessage({ id: 'common_copy_date_column' })}</List.Item> :
                  <>
                    <List.Item onClick={() => handleCopy('current')}>{formatMessage({ id: 'common_copy_this_column' })}</List.Item>
                    <List.Item onClick={() => handleCopy('currentAndDate')}>{formatMessage({ id: 'common_copy_this_column_and_date' })}</List.Item>
                  </>
              }
            </List>
          </div>
        </DropdownBox>
      }
    >
      <div className={`tea-table__sortbtn is-align-${align} ${sortOrder !== 'none' ? 'is-active' : ''}`}>
        {children}
        {/* <Icon
          type={sortOrder === 'asc' ? 'sortup' : (sortOrder === 'desc' ? 'sortdown' : 'sort')}
        /> */}
        <SvgIcon
          type={
            (sortOrder == 'asc' || sortOrder == 'asc_by_rate')
              ? 'arrow-other-up'
              : (sortOrder == 'desc' || sortOrder == 'desc_by_rate')
                ? 'arrow-other-down'
                : 'arrow-down'
          }
        />
      </div>
    </Popover>
  );
}

export default HeatMapTableHeadCell;
